import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const WHY_IMG = '/images/sidekicks/Lebens-Stratege.png';

const Benefits = () => {
  const { t } = useLanguage();

  return (
    <section id="why" className="bg-fog">
      <div className="grid lg:grid-cols-2 min-h-[560px]">
        <div className="relative min-h-[360px] lg:min-h-full overflow-hidden bg-ink">
          <img
            src={WHY_IMG}
            alt={t.why.imageAlt}
            className="absolute inset-0 w-full h-full object-cover object-top"
            width={900}
            height={1200}
          />
        </div>

        <div className="flex items-center px-6 sm:px-10 lg:px-16 py-16 lg:py-20 bg-mint-wash">
          <div className="max-w-md">
            <p className="text-mint text-sm font-bold uppercase tracking-[0.2em]">{t.why.kicker}</p>
            <h2 className="mt-4 font-display font-bold text-4xl lg:text-5xl text-ink leading-tight">
              {t.why.title}{' '}
              <span className="text-mint">{t.why.titleAccent}</span>
            </h2>
            <p className="mt-5 text-lg text-mute leading-relaxed">{t.why.body}</p>

            <ul className="mt-8 space-y-4">
              {t.why.points.map((point) => (
                <li key={point} className="flex gap-3 items-start text-ink font-medium">
                  <span className="mt-2 w-2 h-2 bg-ember shrink-0" aria-hidden />
                  <span>{point}</span>
                </li>
              ))}
            </ul>

            <a
              href="/s"
              className="mt-10 inline-flex items-center gap-2 bg-ink hover:bg-mint-deep text-white px-7 py-3.5 font-bold text-sm transition-colors"
            >
              {t.why.cta}
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
